<template>
  <WidgetWrapp
    :title="title"
    class="best-articles-wrapp"
  >
    <div
      v-for="article in posts"
      :key="article.id"
      class="best-articles-wrapp__item"
    >
      <BestArticlesWidgetItem :article="article" />
      <div class="best-articles-wrapp__item--separator" />
    </div>

    <BaseButton
      aria-label="Перейти в лучшее за неделю"
      class="show-more"
      href="/top/week/"
      @click="sendAnalytics"
    >
      Показать ещё
    </BaseButton>
  </WidgetWrapp>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BaseButton from '@devhacker/shared/components/base/BaseButton.vue';
  import WidgetWrapp from '~/components/WidgetWrapp.vue';
  import BestArticlesWidgetItem from '~/components/BestOfWeekWidget/BestArticlesWidgetItem.vue';
  import type { TArticle } from '~/types/common';
  import getFullUrl from '~/utils/getFullUrl';

  export default defineNuxtComponent({
    name: 'BestArticlesWidget',
    components: { WidgetWrapp, BestArticlesWidgetItem, BaseButton },
    props: {
      posts: {
        type: Array as PropType<TArticle[]>,
        required: true,
      },

      quantity: {
        type: Number as PropType<number>,
        default: 5,
      },

      title: {
        type: String as PropType<string>,
        default: 'Лучшее за неделю',
      },
    },

    computed: {
      articles(): TArticle[] {
        return this.posts.slice(0, this.quantity);
      },
    },

    methods: {
      sendAnalytics() {
        this.$sendYandexMetrika({
          level1: 'Клик_Лучшее за неделю_Показать еще',
          level4: getFullUrl('/top/week/'),
        });
      },
    },
  });
</script>

<style lang="scss" scoped>
  .best-articles-wrapp {
    position: relative;

    &__item:not(:last-of-type) {
      .best-articles-wrapp__item--separator {
        position: absolute;
        left: 0;
        right: 0;
        background: $border-color--2;
        height: 1px;
        margin: 0 auto;
        width: calc(100% - 48px);
      }
    }

    // должно быть внутри, т.к. на главной без этого стили перебиваютя из-за порядка подключения
    .show-more {
      margin: 8px 21px;
    }
  }
</style>
